export default __webpack_public_path__ + "images/defaultAvatar.4e9edb2a624547982816014bf128fcd5.jpg";